<rask-card [renderRaskheader]="false">
    <ng-container>
        <div class="d-flex align-items-center">
            <div class="d-flex">
                <rask-checkbox class="checklist-checkbox" [checked]="fraga.selected" (checkedChange)="onSelectedChanged(fraga, $event)"></rask-checkbox>
            </div>
            {{fraga.beskrivning}}
        </div>
    </ng-container>
</rask-card>